// @ts-ignore
declare const window: any
import { GlobalTrack } from '@didi/global-track'
import { queryURLParams } from './utils'

const GTrack = {
  init: (params: any) => {
    const query = queryURLParams(window.location.href)
    const gTrack = new GlobalTrack()
    gTrack.init({
      // appkey
      appKey: 'omega99baab8c01',
      // 上报地址
      uploadHost: 'omgup.didiglobal.com',
      // omegakey
      omegaKey: 'ibt_fleet_matching_track_ck',
      // 项目名称
      project_id: 'fleet_matching',
      // 国家
      country: query?.location_country || '',
      // 地址
      city: '',
      ...params || {},
    })
    window.gTrack = gTrack
  },

  // 页面pv曝光
  pv: (args: { id: string, params?: any }) => {
    window.gTrack?.Omega && window.gTrack.pv(args)
  },

  // 模块sw曝光
  sw(args: { id: string, params?: any }) {
    window.gTrack?.Omega && window.gTrack.sw(args)
  },

  // 模块ck点击
  ck(args: { id: string, params?: any }) {
    window.gTrack?.Omega && window.gTrack.ck(args)
  },
}

export default GTrack
